import { render, staticRenderFns } from "./APICredsPopup.vue?vue&type=template&id=9922a180&scoped=true&"
import script from "./APICredsPopup.vue?vue&type=script&lang=js&"
export * from "./APICredsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9922a180",
  null
  
)

export default component.exports